import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';

const routes: Routes = [
  { path: 'me-tnt', loadChildren: './codebase/me-tnt/me-tnt.module#MeTntPageModule' },
  { path: 'category-toolbar', loadChildren: './codebase/category/category-toolbar/category-toolbar.module#CategoryToolbarPageModule' },
  { path: 'passport', loadChildren: './passport/passport.module#PassportPageModule' },
  { path: 'i-frame-modal', loadChildren: './i-frame-modal/i-frame-modal.module#IFrameModalPageModule' },
  { path: 'gallery-modal', loadChildren: './gallery-modal/gallery-modal.module#GalleryModalPageModule' },
  { path: 'venues', loadChildren: './passport/venues/venues.module#VenuesPageModule' },
  { path: 'itinerariesv2', loadChildren: './codebase/itinerariesv2/itinerariesv2.module#Itinerariesv2PageModule' },
  { path: 'category-rows', loadChildren: './codebase/category-rows/category-rows.module#CategoryRowsPageModule' },
  { path: 'checkin', loadChildren: './codebase/checkin/checkin.module#CheckinPageModule' },
  { path: 'checkout', loadChildren: './codebase/checkout/checkout.module#CheckoutPageModule' },
  { path: 'lostfound', loadChildren: './codebase/lostfound/lostfound.module#LostfoundPageModule' },
  { path: 'findreservation', loadChildren: './codebase/findreservation/findreservation.module#FindreservationPageModule' },
  { path: 'qrcode', loadChildren: './codebase/qrcode/qrcode.module#QrcodePageModule' },
  { path: 'welcome-checkin', loadChildren: './codebase/sign-up/welcome-checkin/welcome-checkin.module#WelcomeCheckinPageModule' },
  { path: 'roommap', loadChildren: './shared/roommap/roommap.module#RoommapPageModule' },
  { path: 'parking', loadChildren: './shared/parking/parking.module#ParkingPageModule' },
  { path: 'train', loadChildren: './shared/train/train.module#TrainPageModule' },
  { path: 'myroom', loadChildren: './shared/myroom/myroom.module#MyroomPageModule' },
  { path: 'upgrade-room', loadChildren: './codebase/welcome-checkin/upgrade-room/upgrade-room.module#UpgradeRoomPageModule' },
  { path: 'payment', loadChildren: './codebase/checkin/payment/payment.module#PaymentPageModule' },
  { path: 'prearrival', loadChildren: './codebase/prearrival/prearrival.module#PrearrivalPageModule' },
  { path: 'scan', loadChildren: './codebase/prearrival/scan/scan.module#ScanPageModule' },
  { path: 'termsconditions', loadChildren: './codebase/prearrival/termsconditions/termsconditions.module#TermsconditionsPageModule' },
  { path: 'invoice', loadChildren: './codebase/checkout/invoice/invoice.module#InvoicePageModule' },
  { path: 'pages', loadChildren: './codebase/navigation/navigation.module#NavigationPageModule' },
  //{ path: 'folio', loadChildren: './codebase/checkin/folio/folio.module#FolioPageModule' },



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
